var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.375 150.625L210.75 224H32C14.312 224 0 238.312 0 256S14.312 288 32 288H210.75L137.375 361.375C131.125 367.625 128 375.812 128 384S131.125 400.375 137.375 406.625C149.875 419.125 170.125 419.125 182.625 406.625L310.625 278.625C323.125 266.125 323.125 245.875 310.625 233.375L182.625 105.375C170.125 92.875 149.875 92.875 137.375 105.375S124.875 138.125 137.375 150.625ZM384 96V416C384 433.688 398.312 448 416 448S448 433.688 448 416V96C448 78.312 433.688 64 416 64S384 78.312 384 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightToLine);
export default __webpack_public_path__ + "static/media/arrow-right-to-line.9c672b7bb1b5bf23c64fb76d619c8895.svg";
export { ForwardRef as ReactComponent };